angular.module('backOffice').directive('resizer', resizerDirective);

resizerDirective.$inject = ['$window', '$timeout'];

function resizerDirective($window, $timeout) {
    return function (scope, element, attr) {
        const w = angular.element($window);
        scope.$watch(
            () => ({
                h: w.height(),
                w: w.width(),
            }),
            newValue => {
                scope.windowHeight = newValue.h;
                scope.windowWidth = newValue.w;

                scope.resizeWithOffset = function (offsetH) {
                    return {
                        height: `${Math.max(newValue.h - offsetH, 200)}px`,
                    };
                };

                scope.resizeWithOffsetWidth = function (offsetH) {
                    return {
                        height: `${Math.max(newValue.h - offsetH, 200)}px`,
                        width: '295px',
                    };
                };
                scope.resizeWithOffsetMaxHeight = function (offsetH) {
                    return {
                        'max-height': `${newValue.h - offsetH}px`,
                    };
                };

                scope.resizeWithOffsetW = function (offsetW) {
                    return {
                        width: `${newValue.w - offsetW}px`,
                    };
                };

                scope.setHeight = function () {
                    const height = element[0].querySelector('.panel').offsetHeight;
                    return {
                        'margin-top': `-${height / 2}px`,
                    };
                };

                scope.pageWrapper = function (offsetW) {
                    let result = '0px';

                    if (newValue.w <= offsetW) {
                        result = '65px';
                    }
                    return {
                        'margin-top': result,
                    };
                };

                scope.documentWidthIsSmaller = function (offsetW) {
                    let isSmaller = false;

                    if (newValue.w <= offsetW) {
                        isSmaller = true;
                    }
                    return isSmaller;
                };
            },
            true
        );

        w.bind('resize', () => {
            $timeout(() => {
                scope.$apply();
            });
        });
    };
}
